import {
    defaultWrittenResponseItemDTO,
    WrittenResponseItemDTO,
} from 'src/models/dto/items/WrittenResponseItemDTO'
import { Locale } from '../../../models/dto/Locale'
import { factories, ITEM_ENTITY_STORE_SELECTOR } from '../ItemEntityService'
import { ItemDTO, ItemType } from './../../../models/dto/items/ItemDTO'
import { Stores } from './../../Store'

const itemType = ItemType.WrittenResponse

export class WrittenResponseHandler {
    static init() {
        // add the create function to the set of factories available in ItemEntityService
        factories.set(itemType, () => WrittenResponseHandler.create())
    }

    private static store() {
        return Stores.get<WrittenResponseItemDTO, ItemDTO>(ITEM_ENTITY_STORE_SELECTOR)
    }

    static create(): WrittenResponseItemDTO {
        return defaultWrittenResponseItemDTO()
    }

    private static assign(id: string, obj: Partial<WrittenResponseItemDTO>) {
        this.store().assign(id, obj)
    }

    static updateLabel(id: string, label: string) {
        this.assign(id, { label })
    }

    static updateOptional(id: string, optional: boolean) {
        this.assign(id, { optional })
    }

    static updatePreserveOrder(id: string, preserveOrder: boolean) {
        this.assign(id, { preserveOrder })
    }

    static updateQuestion(id: string, locale: Locale, nextValue: string) {
        this.store().produce(id, (entity) => {
            entity.questionI18N[locale] = nextValue
        })
    }

    static updateMinCharacterLimit(id: string, minCharacterLimit: number | null) {
        this.assign(id, { minCharacterLimit: minCharacterLimit ?? 0 })
    }

    static updateMaxCharacterLimit(id: string, maxCharacterLimit: number | null) {
        this.assign(id, { maxCharacterLimit: maxCharacterLimit ?? 0 })
    }
}
